import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../store";

export const availableFundraisingsSelector = createSelector(
  [(state: RootState) => state.user.permissions, (state: RootState) => state.user.clientCode],
  (permissions, clientCode) => permissions.find((p) => p.clientCode === clientCode)?.fundraisings ?? []
);
